import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['image'];

  connected() {
    if (this.imageTarget.complete) {
      this.#showImage();
    }
  }

  onLoad() {
    this.#showImage();
  }

  #showImage() {
    this.imageTarget.classList.replace('opacity-0', 'opacity-100');
    this.element.classList.remove('animate-pulse', 'border');
  }
}
